// extracted by mini-css-extract-plugin
var _1 = "license__dkUXD";
export { _1 as "license" }
export default { "license": _1 }
